<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-left-text">
          <div>自定义任务&nbsp;/&nbsp;</div>
        </div>
        <div class="box-header-right" v-if="activeName == 'first'">
          <div>长期巡查任务</div>
        </div>
        <div class="box-header-right" v-if="activeName == 'second'">
          <div>非长期巡查任务</div>
        </div>
        <div class="box-header-right" v-if="activeName == 'third'">
          <div>一次性任务</div>
        </div>
      </div>
    </div>
    <div class="ledger">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="长期巡查任务" name="first">
          <longTermInspectionTask v-if="activeName == 'first'"></longTermInspectionTask>
        </el-tab-pane>
        <!-- <el-tab-pane label="非长期巡查任务" name="second">
          <nonLongTermInspectionTasks v-if="activeName == 'second'"></nonLongTermInspectionTasks>
        </el-tab-pane>
        <el-tab-pane label="一次性任务" name="third">
          <oneTimeTask v-if="activeName == 'third'"></oneTimeTask>
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import commonTable from "@/components/table/index.vue";
import longTermInspectionTask from "@/pages/task/customTask/components/longTermInspectionTask.vue";
import nonLongTermInspectionTasks from "@/pages/task/customTask/components/nonLongTermInspectionTasks.vue";
import oneTimeTask from "@/pages/task/customTask/components/oneTimeTask.vue";

export default {
  name: "index",
  components: {
    commonTable,
    longTermInspectionTask,
    nonLongTermInspectionTasks,
    oneTimeTask
  },
  data() {
    return {
      form: {
        patrolCompletionTime: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "ghEventTypeSxlx",
            label: "巡逻单位类型"
          },
          {
            prop: "ghEventTypeSxlx",
            label: "任务ID"
          },
          {
            prop: "ghEventManageSxmc",
            label: "巡逻点位"
          },
          {
            prop: "zbmc",
            label: "巡逻网格"
          },
          {
            prop: "fzqz",
            label: "事项类型"
          },
          {
            prop: "khdx",
            label: "事项名称"
          },
          {
            prop: "khdx",
            label: "是否应急事项"
          },
          {
            prop: "fzqz",
            label: "巡逻状态"
          },
          {
            prop: "khdx",
            label: "巡逻完成时间"
          },
          {
            prop: "khdx",
            label: "巡逻人"
          }
        ]
      },
      typeList: [],
      emergencyMattersList: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      patrolStatusList: [
        {
          label: "巡查无问题",
          value: 1
        },
        {
          label: "超期未完成",
          value: 2
        },
        {
          label: "即将超期",
          value: 3
        },
        {
          label: "待执行",
          value: 4
        },
        {
          label: "巡查有问题",
          value: 5
        }
      ],
      activeName: 'first'
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
    },
    handleCurrentChange(val) {
      this.page.page = val;
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
    },
    handleClick() {}
  }
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";

/deep/ .el-icon-upload2:before {
  margin-right: 5px;
}

.ledger {
  background: #fff;
  padding: 16px 20px;
  height: calc(100% - 60px);
  .el-tabs {
    background: #fff;
  }
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/task/customTask/index.vue